module.exports = __webpack_public_path__ + "static/media/calendar.fac9da5d.svg";